function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/arrayWithHoles.js
// module id = 627
// module chunks = 0